var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3653 6.1532L1.86153 0.159446C1.64006 0.0353893 1.38608 -0.0183014 1.13336 0.00551486C0.880633 0.0293311 0.64115 0.129525 0.446762 0.292771C0.252373 0.456017 0.112292 0.674576 0.0451515 0.919378C-0.0219894 1.16418 -0.0130079 1.42362 0.0709011 1.6632L1.95715 7.2482L0.0709011 12.8332C0.00458606 13.0216 -0.0156109 13.2232 0.0120022 13.421C0.0396153 13.6188 0.114234 13.8072 0.229608 13.9702C0.344982 14.1333 0.497751 14.2663 0.675117 14.3582C0.852484 14.45 1.04928 14.498 1.24903 14.4982C1.46383 14.4977 1.67492 14.4422 1.86215 14.3369L1.86778 14.3332L12.3678 8.32882C12.5603 8.21984 12.7204 8.06172 12.8319 7.87061C12.9433 7.6795 13.002 7.46223 13.002 7.24101C13.002 7.01978 12.9433 6.80252 12.8319 6.61141C12.7204 6.42029 12.5603 6.26217 12.3678 6.1532H12.3653ZM1.6984 12.7019L3.28715 7.9982H6.74903C6.94794 7.9982 7.1387 7.91918 7.27936 7.77853C7.42001 7.63787 7.49903 7.44711 7.49903 7.2482C7.49903 7.04928 7.42001 6.85852 7.27936 6.71787C7.1387 6.57721 6.94794 6.4982 6.74903 6.4982H3.28715L1.69778 1.7932L11.2453 7.24132L1.6984 12.7019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSend);
export default __webpack_public_path__ + "static/media/chat-send.ce77dfa2a2814a474c1df855105dbce1.svg";
export { ForwardRef as ReactComponent };